import { connect } from 'react-redux';

import { AppState } from 'src';
import FormNames from '@constants/FormNames.enum';
import { VendorViewModel } from '@models/Vendor';

import { VendorEditComponentProps, VendorEditComponent } from './vendor-edit.component';
import { fillInVendorForm, GetVendorDetailsSuccessAction, saveVendor, clearVendorFull } from '../../../vendor.actions';
import { AppDispatcher } from '../../../../_models/common.models';
import { getVendorDetails } from 'src/vendor/vendor.actions';

enum TabNumbers {
  GeneralInfo = 0,
  AddressNFinances,
  CoverageAndLimits,
  DefaultRatings
}

function mapStateToProps(state: AppState, ownProps: {}): Partial<VendorEditComponentProps> {
  const generalInfo: Partial<VendorViewModel> = state[FormNames.VendorGeneralInfo];
  const addressNFinances: Partial<VendorViewModel> = state[FormNames.VendorAddressNFinances];
  const coverageNLimits: Partial<VendorViewModel> = state[FormNames.VendorCoverageNLimits];
  const defaultRatings: Partial<VendorViewModel> = state[FormNames.VendorDefaultRatings];

  return {
    vendor: state.vendor.vendorVM,
    saving: state.vendor.saving || undefined,
    currentFormState: {
      ...generalInfo,
      ...addressNFinances,
      ...coverageNLimits,
      ...defaultRatings
    },
    checkIsTabValid: (fromTab: number) => {
      const map = {
        [TabNumbers.GeneralInfo]: FormNames.VendorGeneralInfo,
        [TabNumbers.AddressNFinances]: FormNames.VendorAddressNFinances,
        [TabNumbers.CoverageAndLimits]: FormNames.VendorCoverageNLimits,
        [TabNumbers.DefaultRatings]: FormNames.VendorDefaultRatings
      };
      const form = state.forms[map[fromTab]].$form;
      return form.valid && !form.validating;
    }
  };
}

function mapDispatchToProps(dispatch: AppDispatcher, ownProps: {}): Partial<VendorEditComponentProps> {
  return {
    getVendorDetails: (id: number) => {
      dispatch(getVendorDetails(+id)).then((vendorAction?: GetVendorDetailsSuccessAction) => {
        if (!vendorAction) {
          return;
        }
        dispatch(fillInVendorForm(vendorAction.vendorVM));
      });
    },
    saveAllTabs: (vendor: VendorViewModel, updates: Partial<VendorViewModel>) => {
      const newVendor = {
        ...vendor,
        ...updates
      };
      dispatch(saveVendor(newVendor));
    },
    clearVendor: () => {
      dispatch(clearVendorFull());
    }
  };
}

export const VendorEdit = connect(
  mapStateToProps,
  mapDispatchToProps
)(VendorEditComponent);



// WEBPACK FOOTER //
// ./src/vendor/_components/flows/vendor-edit/vendor-edit.container.ts